export default "__VITE_ASSET__CsPK0Rg5__"